import React from 'react';
import c from 'classnames';
import { useTranslation } from 'react-i18next';
import SolidButton from '@wix/da-ds/pkg/Buttons/SolidButton';
import BrandedButton from '@wix/da-ds/pkg/Buttons/BrandedButton';
import CoreIcon from '@wix/da-ds/pkg/Icons/24x24/Core';
import EmptyState from '../../../EmptyState';
import s from './SubscriptionsCoreOnlyBlock.scss';
import { URLS } from '@wix/da-url/dist/src/constants';

export interface Props {
  className?: string;
  hasCore: boolean;
  createTier: () => void;
}

const SubscriptionsCoreOnlyBlock: React.FC<Props> = ({
  className,
  hasCore,
  createTier,
}) => {
  const { t } = useTranslation();

  return (
    <EmptyState
      className={c(s['root'], className)}
      title={t(
        `page.subscriptions.coreOnlyBlock.title.${
          hasCore ? 'hasCore' : 'noCore'
        }`
      )}
      subtitle={
        <div className={s['subtitle-wrapper']}>
          <div className={s['subtitle']}>
            {t(
              `page.subscriptions.coreOnlyBlock.subtitle.${
                hasCore ? 'hasCore' : 'noCore'
              }`
            )}
          </div>
          <div className={s['subtitle-highlighted']}>
            <CoreIcon className={s['core-icon']} />
            {t(
              `page.subscriptions.coreOnlyBlock.subtitle.highlighted.${
                hasCore ? 'hasCore' : 'noCore'
              }`
            )}
          </div>
        </div>
      }
      illustration={<div className={s['illustration']} />}
      withIllustrationBelow
      customButton={
        hasCore ? (
          <SolidButton
            variant="approval-green"
            size="medium"
            priority="primary"
            onClick={createTier}
          >
            {t('page.subscriptions.coreOnlyBlock.CTAbutton.createTier')}
          </SolidButton>
        ) : (
          <BrandedButton
            size="medium"
            variant="core-orange"
            href={URLS.CORE_MEMBERSHIP}
          >
            {t('page.subscriptions.coreOnlyBlock.CTAbutton.buyCore')}
          </BrandedButton>
        )
      }
    />
  );
};
SubscriptionsCoreOnlyBlock.displayName = 'SubscriptionsCoreOnlyBlock';

export default SubscriptionsCoreOnlyBlock;
